import ambitionplus from '../../assets/shapes_svg/ambition/ambitionplus.svg'
import './AddSubGoal.css'
import { useState } from 'react'
import SaveChangeIcon from '../../components/EditIconTable/SaveChangeIcon'
import DiscardChangeIcon from '../../components/EditIconTable/DiscardChangeIcon'


export const AddGoal = ({style}) => {
    const [add,setAdd] = useState(false);

    return ( 
        <>
        {
            !add ?<div className={"addsubgoal " + (style == 2 ? "subgoal__style2":"")} 
                onClick={()=> setAdd(true)}
                style={{width:"50%"}}>
                <img src={ambitionplus} alt="plus icon" />
                <h4>Add Goal</h4>
            </div>
            :<div className={"addsubgoal " + (style == 2 ? "subgoal__style2":"")}  
                onClick={()=> setAdd(true)}
                style={{width:"50%"}}>
                <input className='custom__input' type="text" autoFocus placeholder='Enter a text' style={{fontSize:"20px"}}/>
                <div className="addsubgoal__option">
                    <SaveChangeIcon/>
                    <DiscardChangeIcon/>
                </div>
                
            </div>
        }
        </>
     );
}

const AddSubGoal = ({style}) => {
    const [add,setAdd] = useState(false);

    return ( 
        <>
        {
            !add ?<div className={"addsubgoal " + (style == 2 ? "subgoal__style2":"")} 
                onClick={()=> setAdd(true)}>
                <img src={ambitionplus} alt="plus icon" />
                <h4>Add Sub-Goal</h4>
            </div>
            :<div className={"addsubgoal " + (style == 2 ? "subgoal__style2":"")}  
                onClick={()=> setAdd(true)}>
                <input className='custom__input' type="text" autoFocus placeholder='Enter a text'/>
                <div className="addsubgoal__option">
                    <SaveChangeIcon/>
                    <DiscardChangeIcon/>
                </div>
                
            </div>
        }
        </>
     );
}
 
export default AddSubGoal;